import React, { useState } from 'react';
import './Navbar.css';

const Navbar = ({ onGoToApp , onGoToRegister }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const handleGoToApp = () => {
    onGoToApp();
    closeMenu();
  };

  const handleGoToRegister = () => {
    onGoToRegister();
    closeMenu();
  };
 
  const closeMenu = () => {
    setIsOpen(false);
  };
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="/" className="navbar-logo">
          <img src="/logonuevo.png" alt="Logo" className="logo-img" />
        </a>
        
        <div  className={`navbar-menu-links ${isOpen ? 'active' : ''}`}>
          <button className="navbar-close-btn" onClick={closeMenu}>
            ✕
          </button>
          <a href="/" className="nav-link">
            Inicio
          </a>
          <a href="#how-it-works" className="nav-link" onClick={closeMenu}>¿Cómo funciona?</a>
          <a href="#faqs" className="nav-link" onClick={closeMenu}>Preguntas&#10;Frecuentes</a>
          <a href="#guia-uso" className="nav-link" onClick={closeMenu}>Guía de Uso</a>
          <a href="/contact" className="nav-link" onClick={closeMenu}>Contáctenos</a>
          <div className="mobile-buttons">
            <button className="mobile-use-app-btn" onClick={handleGoToApp}>
              Inicio de sesión
            </button>
            <button className="mobile-register-btn" onClick={handleGoToRegister}>
              Registrarse
            </button>
          </div>
        </div>
        
        <div className="use-app-btn-container">
          <button className="use-app-btn" onClick={onGoToApp}>
            Inicio de sesión
          </button>
          <button className="register-btn" onClick={onGoToRegister}>
            Registrarse
          </button>
        </div>
        
        <div className="navbar-toggle" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
